import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";

import "./LoginForm.css";

const LoginForm = () => {
  const navigate = useNavigate();

  const { login } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    setError("");

    if (!email.trim()) {
      setError("Email is required");
      return;
    }

    if (!password) {
      setError("Password is required");
      return;
    }

    setLoading(true);

    try {
      const loggedInUser = await login(
        email.trim().toLowerCase(),
        password
      );

      console.log(
        "LOGIN SUCCESS:",
        loggedInUser
      );

      navigate("/users", {
        replace: true,
      });
    } catch (error) {
      console.error(
        "LOGIN ERROR:",
        error
      );

      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Unable to login. Please check your email and password.";

      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">

      {/* Background decoration */}
      <div className="login-bg-shape login-bg-shape-one" />
      <div className="login-bg-shape login-bg-shape-two" />

      <div className="login-container">

        <div className="login-card">

          {/* ============================================================
              LEFT BRAND PANEL
          ============================================================ */}

          <div className="login-brand-panel">

            <div className="login-brand-content">

              {/* Logo */}
              <div className="login-brand-header">

                <div className="login-logo">
                  H
                </div>

                <div>
                  <h1>
                    Harsha Enterprises
                  </h1>

                  <p>
                    Management System
                  </p>
                </div>

              </div>

              {/* Main message */}
              <div className="login-brand-message">

                <span className="login-brand-label">
                  WELCOME
                </span>

                <h2>
                  Manage your business
                  <span>
                    with confidence.
                  </span>
                </h2>

                <p>
                  Access your dashboard, manage
                  users, offerings, categories and
                  keep your business operations
                  organized in one place.
                </p>

              </div>

              {/* Footer */}
              <div className="login-brand-footer">
                Secure business management platform
              </div>

            </div>

          </div>

          {/* ============================================================
              RIGHT LOGIN PANEL
          ============================================================ */}

          <div className="login-form-panel">

            {/* Mobile brand */}
            <div className="login-mobile-brand">

              <div className="login-mobile-logo">
                H
              </div>

              <h1>
                Harsha Enterprises
              </h1>

              <p>
                Management System
              </p>

            </div>

            {/* Heading */}
            <div className="login-heading">

              <span>
                Welcome back
              </span>

              <h2>
                Sign in
              </h2>

              <p>
                Sign in to access your account
                and dashboard.
              </p>

            </div>

            {/* Error */}
            {error && (
              <div className="login-error">

                <div className="login-error-icon">
                  !
                </div>

                <p>
                  {error}
                </p>

              </div>
            )}

            {/* Form */}
            <form
              onSubmit={handleSubmit}
              className="login-form"
            >

              {/* Email */}
              <div className="login-field">

                <label htmlFor="email">
                  Email address
                </label>

                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(event) =>
                    setEmail(event.target.value)
                  }
                  placeholder="Enter your email"
                  autoComplete="email"
                  disabled={loading}
                />

              </div>

              {/* Password */}
              <div className="login-field">

                <label htmlFor="password">
                  Password
                </label>

                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(event) =>
                    setPassword(event.target.value)
                  }
                  placeholder="Enter your password"
                  autoComplete="current-password"
                  disabled={loading}
                />

              </div>

              {/* Submit */}
              <button
                type="submit"
                className="login-submit"
                disabled={loading}
              >

                {loading ? (
                  <>
                    <span className="login-spinner" />
                    Signing in...
                  </>
                ) : (
                  "Sign in"
                )}

              </button>

            </form>

            {/* Secure access */}
            <div className="login-secure">

              <span />

              <p>
                Secure access
              </p>

              <span />

            </div>

            {/* Footer */}
            <div className="login-footer">
              © {new Date().getFullYear()} Harsha Enterprises
            </div>

          </div>

        </div>

      </div>

    </div>
  );
};

export default LoginForm;